export default "__VITE_ASSET__xYeJjebR__"